import { useState } from 'react';
import { createContainer } from 'unstated-next';

// 热门榜相关的状态
const useRankStore = (initialState = { list: [] }) => {
    const [rankStates, setRankStates] = useState(initialState);

    const changeRankStates = newListStates => {
        setRankStates(prevStates => Object.assign({}, prevStates, newListStates));
    };

    return { rankStates, changeRankStates };
};

export const RankStore = createContainer(useRankStore);

// 列表相关的状态
const useListStore = (
    initialState = {
        page: 1,
        size: 10,
        total: 0,
        nodes: [],
    },
) => {
    const [listStates, setListStates] = useState(initialState);

    const changeListStates = newListStates => {
        setListStates(prevStates => Object.assign({}, prevStates, newListStates));
    };

    return { listStates, changeListStates };
};

export const ListStore = createContainer(useListStore);
